import { decodePatternColorCombinationWishList } from 'features/scene7';
import { addToWishList, removeFromWishList, showAddToWishListError } from 'features/wishList/desktop';
import { addClassDuringActivity } from 'utilities/dom';
import { utagFbAddToWishlist, utagLinkPDP, getProductPriceNameFromData } from 'features/tealium';
import { showErrorMessage } from 'utilities/errorMessage/desktop';

/* wishlist is shared on pdp and quicklook */
// TODO: page modules should not be shared: separate Quicklook from PDP
function initWishList () {

	const helpers = {
		// prod detail add to wish list
		addItemsToWishlist (data, el) {

			const wishListButtonTextElement = $(el).find('span.wish-list-button-text');

			if (!$(el).hasClass('ignoreSaved')) {

				$(el).addClass('saved');
				wishListButtonTextElement.text('Saved');

			}

			const request = addToWishList(
				data,
				(response) => {

					// if button should behave as save => saved,
					// other buttons like in housing options don't behave like normal add to wishlist
					const element = $(el);
					const qlBkg = document.getElementById('qlBkg');
					if (!element.hasClass('ignoreSaved') && response.Item.AddedShortSkus.length) {

						window.lp.wishlist.activeWishlistToken = response.CurrentWishListToken;
						element.attr('data-wishlist-item-id', response.Item.AddedShortSkus[0].WishListItemId);
						element.addClass('saved');
						wishListButtonTextElement.text('Saved');
						if (
							document.querySelectorAll('.isHospitality').length
							&& !element.parent().hasClass('addForQuotePanel')
						) {

							element.addClass('alt2');

						}

					}
					if (window.utag_data.page_type === 'product' && !qlBkg) {

						const savedNotification = document.querySelector('.savedNotification');
						const hideSaveAlret = () => {

							savedNotification.classList.add('hidden');
							document.removeEventListener('click', hideSaveAlret, false);
							document.removeEventListener('scroll', hideSaveAlret, false);

						};
						document.addEventListener('click', hideSaveAlret, false);
						document.addEventListener('scroll', hideSaveAlret, false);
						savedNotification.classList.remove('hidden');

					}

				},
				(maxItemCountReached) => {

					if (maxItemCountReached) {

						showAddToWishListError(maxItemCountReached);

					} else {

						$(el).removeClass('saved');
						wishListButtonTextElement.text('Save');

					}

				}
			);

			addClassDuringActivity($(el).get(0), 'noPointerEvents', request);

		},

		removeItemsFromWishlist (e) {

			const el = e.currentTarget;
			const wishListButtonTextElement = $(el).find('span.wish-list-button-text');

			el.classList.add('noPointerEvents');
			el.classList.remove('saved');
			wishListButtonTextElement.text('Save');

			const dataArray = [
				{
					wishlistToken: window.lp.wishlist.activeWishlistToken,
					wishlistItemId: e.currentTarget.dataset.wishlistItemId
				}
			];

			const successCallback = () => {

				el.classList.remove('noPointerEvents');

				if (
					document.querySelectorAll('.isHospitality').length
					&& !el.parentElement.classList.contains('addForQuotePanel')
				) {

					el.classList.remove('alt2');

				}

			};

			const errorCallback = () => {

				el.classList.remove('noPointerEvents');
				el.classList.add('saved');

			};

			// remove item from wishlist
			removeFromWishList(dataArray, successCallback, errorCallback);

		}
	};

	const ui = {
		addToWishlistButtons: document.querySelectorAll('#pdAddToPortfolioNormal, #addForQuoteButton'),
		wishlistAddDimmer: document.querySelector('#WishListAddDimmer'),
		pdAddToPortfolioMultiProduct: document.querySelector('#pdAddToPortfolioMultiProduct'),
		pdAddToPortfolioSystemOptions: document.querySelector('#pdAddToPortfolioSystemOptions'),
		pdHousingOptionAddToWishlist: document.querySelectorAll('.pdHousingOptionAddToWishlist'),
		pdWorkStationBasesThumb: document.querySelectorAll('.pdWorkStationBasesThumb'),
		addForQuoteButton: document.querySelector('#addForQuoteButton')
	};

	const events = {
		addToWishlistNormal (e) {

			e.preventDefault();

			if (e.currentTarget.classList.contains('saved') && e.currentTarget.id !== 'addForQuoteButton') {

				helpers.removeItemsFromWishlist(e);

			} else {

				const { pdWorkStationBasesThumb } = ui;
				const data = [
					{
						ShortSku: window.shortSku,
						Quantity: Number($('#QtyNormal').val()) || 1,
						Pattern: decodePatternColorCombinationWishList(window.patternSerial)
					}
				];
				if (pdWorkStationBasesThumb) {

					const workStationBases = document.querySelectorAll('input[name="workStationBases"]');

					workStationBases.forEach((workStationBase) => {

						if (workStationBase.checked) {

							const workStationBasesSku = workStationBase.value;
							if (Number(workStationBasesSku) !== 0 && typeof workStationBasesSku !== 'undefined') {

								data.push({
									ShortSku: workStationBasesSku,
									Quantity: Number($('#QtyNormal').val()) || 1
								});

							}

						}

					});

				}

				helpers.addItemsToWishlist(data, $(ui.addToWishlistButtons));

				utagFbAddToWishlist();

			}

		},
		addToWishListDimmer (e) {

			e.preventDefault();

			if (e.currentTarget.classList.contains('saved')) {

				helpers.removeItemsFromWishlist(e);

			} else {

				const facePlateOption = document.querySelector('#dimmerWithFacePlateOption');
				const qtyDimmerCombo = document.querySelector('#QtyDimmerCombo');
				const qty = qtyDimmerCombo && qtyDimmerCombo.value ? Number(qtyDimmerCombo.value) : 1;

				const { wishlistAddDimmer } = ui;

				if (facePlateOption) {

					const arrData = facePlateOption.checked
						? [
							{
								ShortSku: window.shortSku,
								Quantity: qty
							},
							{
								ShortSku: facePlateOption.value,
								Quantity: qty
							}
						  ]
						: [
							{
								ShortSku: window.shortSku,
								Quantity: qty
							}
						  ];

					if (wishlistAddDimmer) {

						helpers.addItemsToWishlist(arrData, wishlistAddDimmer);

						utagFbAddToWishlist();

					}

				}

			}

		},
		addToWishlistMultiProd (e) {

			e.preventDefault();

			if (e.currentTarget.classList.contains('saved')) {

				helpers.removeItemsFromWishlist(e);

			} else {

				const { pdAddToPortfolioMultiProduct } = ui;

				const data = [
					{
						ShortSku: window.shortSku,
						Quantity: Number($('#QtyMultiProd').val()) || 1
					}
				];

				if (pdAddToPortfolioMultiProduct) {

					helpers.addItemsToWishlist(data, pdAddToPortfolioMultiProduct);

				}

				const selectedOption = document.querySelector('.multiProdSizeOptions__option.selected');

				if (selectedOption) {

					const [ price, name ] = getProductPriceNameFromData(selectedOption);
					if (price && name) {

						utagFbAddToWishlist(price, name);

					}

				}

			}

		},
		addToWishlistSystemOptions (e) {

			e.preventDefault();
			const { pdAddToPortfolioSystemOptions } = ui;
			const systemOptionsQty = document.querySelectorAll('.systemOptionsQty');
			const data = [];

			if (systemOptionsQty.length) {

				systemOptionsQty.forEach((input, i) => {

					const qty = Number(input.value) || 0;
					if (qty > 0) {

						const product = {
							ShortSku: window.arySkus[i],
							Quantity: qty
						};
						data.push(product);

						const [ price, name ] = getProductPriceNameFromData(input);

						if (price && name) {

							utagFbAddToWishlist(price, name);

						}

					}

				});

			}

			if (data.length) {

				if (pdAddToPortfolioSystemOptions) {

					utagLinkPDP()({
						eventAction: `Save-To-Wishlist-${window.utag_data.product_category[0]}-BFS`,
						eventLabel: `${window.location.pathname}-${data.map((p) => p.ShortSku).join(',')}`
					});
					helpers.addItemsToWishlist(data, pdAddToPortfolioSystemOptions);

				}

			} else {

				showErrorMessage({
					errors: 'Please enter a quantity for one or more products.',
					title: '',
					modal: {
						height: 80
					}
				});

			}

		},
		addToWishlistHousingOptions (e) {

			// don't need to check for remove here because it is only for main add to wishlist buttons
			e.preventDefault();

			const { currentTarget } = e;

			if (!currentTarget.classList.contains('saved')) {

				const pdHousingOptionsQTYfield = currentTarget.parentNode.querySelector('.pdHousingOptionsQTY');

				const qty = pdHousingOptionsQTYfield ? Number(pdHousingOptionsQTYfield.value) : 1;
				const shortSku = currentTarget.dataset.shortsku;
				const data = [
					// add main product to Wish List too
					{
						ShortSku: window.shortSku,
						Quantity: qty
					},
					{
						ShortSku: shortSku,
						Quantity: qty
					}
				];

				if (shortSku) {

					helpers.addItemsToWishlist(data, this);

				}

				const [ price, name ] = getProductPriceNameFromData(currentTarget);
				if (price && name) {

					utagFbAddToWishlist(price, name);

				}

			}

		},
		addForQuote () {

			$('body').lpModal({
				onInit: true,
				content: $('#addForQuoteModal'),
				appendContentToForm: false,
				height: 200,
				width: 650,
				openEvt () {

					$('#continueShoppingButton').on('click', () => {

						$('body').lpModalClose();

					});

				}
			});

		}
	};

	function init () {

		const {
			addToWishlistButtons,
			wishlistAddDimmer,
			pdAddToPortfolioMultiProduct,
			pdAddToPortfolioSystemOptions,
			pdHousingOptionAddToWishlist,
			addForQuoteButton
		} = ui;

		const {
			addToWishlistNormal,
			addToWishListDimmer,
			addToWishlistMultiProd,
			addToWishlistSystemOptions,
			addToWishlistHousingOptions,
			addForQuote
		} = events;

		if (addToWishlistButtons.length) {

			addToWishlistButtons.forEach((btn) => {

				btn.addEventListener('click', addToWishlistNormal);

			});

		}

		if (wishlistAddDimmer) {

			wishlistAddDimmer.addEventListener('click', addToWishListDimmer);

		}
		if (pdAddToPortfolioMultiProduct) {

			pdAddToPortfolioMultiProduct.addEventListener('click', addToWishlistMultiProd);

		}
		if (pdAddToPortfolioSystemOptions) {

			pdAddToPortfolioSystemOptions.addEventListener('click', addToWishlistSystemOptions);

			$(pdAddToPortfolioSystemOptions).lpTooltip({
				tooltip: $('#pdAddToPortfolioSystemOptionsTooltip'),
				useParentOffset: true,
				evtType: 'click',
				arrow: true,
				arrowBorderWidth: 1,
				arrowBorderColor: '#999',
				offsetX: -8, // offset the position of the tooltip on the x axis - use positive or negative integers
				offsetY: 12,
				horzAlign: 'center', // horizontal position of tooltip - options are left, center, and right
				vertAlign: 'bottom',
				preOpenEvt: () => {

					const systemOptionsQty = document.querySelectorAll('.systemOptionsQty');
					let totalQty = 0;

					if (systemOptionsQty.length) {

						systemOptionsQty.forEach((input) => {

							const qty = Number(input.value) || 0;
							if (qty > 0) {

								totalQty += qty;

							}

						});

					}

					document.querySelector('.totalItems').innerHTML = totalQty + (totalQty > 1 ? ' Items' : ' Item');

					setTimeout(() => {

						$(pdAddToPortfolioSystemOptions).trigger('forceClose.lpTooltip');

					}, 5000);

					return true;

				}
			});

		}

		if (pdHousingOptionAddToWishlist.length) {

			pdHousingOptionAddToWishlist.forEach((button) => {

				button.addEventListener('click', addToWishlistHousingOptions);

			});

		}

		if (addForQuoteButton) {

			addForQuoteButton.addEventListener('click', addForQuote);

		}

	}

	return Object.freeze({ init });

}

export default initWishList;
